/* eslint-disable react-hooks/exhaustive-deps */
/**
 * @author Benjamin Viaud
 * @copyright Horizon-Pharma
 */

import React, { useEffect, useState } from 'react';
import { connect, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';

import { Button, Checkbox, FormControl, Select } from '@material-ui/core';

import ElementDeSelectionOption from './elementDeSelectionOption';
import valuesQuery from '../../components/Utils/valuesQuery';
import { GET, POST } from '../../components/Utils/requete';

import useStylesMaterielUIGlobal from '../../styles/StyleMaterielUIGlobal';
import creationTableauFiltre from '../../components/Utils/createTableauFiltre';
import valeurParametre from '../../components/Utils/requeteParametre/valeurParametre';
import DialogCustom from '../../components/organism/Dialog/dialog';

const OptionOffre = (props) => {
    const user = useSelector((state) => state.Utilisateur);
    const css = useStylesMaterielUIGlobal();
    const usurpation = user.userC;
    const dataChoixOffre = useSelector((state) => state.DataInscriptionTarn.choixOffre);
    const dataOffre = useSelector((state) => state.DataInscriptionTarn.eleves);
    const history = useHistory();
    const [errorMessage, setErrorMessage] = useState();
    const [nonScolarise, setNonScolarise] = useState(valuesQuery('SE') === 'true');
    const [dataFiltre, setDataFiltre] = useState({
        communes: [],
        etablissement: [],
        niveau: [],
    });
    const [fraitInscription, setFraitInscription] = useState(0);
    const [open, setOpen] = useState(false);
    const [scolaritesExterne, setScolaritesExterne] = useState({
        idScolarite: 0,
        fk_eleve: null,
        fk_anneeScolaire: null,
        fk_etablissementScolaire: null,
        fk_niveauScolaire: null,
        coursMercrediMatin: 0,
    });
    const [parametresDroit, setParametresDroit] = useState(0);
    const [checkecedCourMercredi, setCheckecedCourMercredi] = useState(false);
    const [droitImage, setDroitImage] = useState(valuesQuery('droitImage'));
    const [condition, setCondition] = useState(valuesQuery('condition'));
    const [cssText, setCssText] = useState('none');
    const [CGUInscription, setGCUInscription] = useState();
    const [reinscription, setReincription] = useState();

    let option = ['site', 'observation'];
    if (dataChoixOffre) {
        if (option.includes('site') && dataChoixOffre.instrument) {
            const ajoutInstrument = option.filter((e) => e !== 'site');
            ajoutInstrument.unshift('site/instrument');
            option = ajoutInstrument;
        }
        if (dataChoixOffre.style) {
            option.splice(option.length - 1, 0, 'disciplines');
        }
        const idOffrePratiqueColective = [40, 3, 47];
        if (idOffrePratiqueColective.includes(dataOffre[valuesQuery('numeroEleve') - 1].scolarites[valuesQuery('numeroOffre') - 1].fk_offre)) {
            option.splice(option.length - 1, 0, 'listePratiqueCollective');
        }
    }
    async function parametreDroitImage() {
        const droitImage = await GET(`/api/parametres/getValeur/droitImage`);
        setParametresDroit(droitImage.data.valeur);
        const response = await GET('/api/parametres/list?categorie=inscription');
        let index = response.data.findIndex((e) => e.cle === 'idCGUInscription');
        const GCUInscription = await GET(`/api/informations/${response.data[index].valeur}`);
        setGCUInscription(GCUInscription.data);

        index = response.data.findIndex((e) => e.cle === 'anneeInscriptions');
        setReincription(response.data[index]);
    }

    async function requeteSitesEtablissements() {
        const siteFiltre = await GET('/api/eleves/SE_etablissements?mode=communes', undefined, {
            redirectOnError: false,
        });
        setDataFiltre((prevState) => ({
            ...prevState,
            communes: creationTableauFiltre(siteFiltre.data, '', 'commune'),
        }));
        const niveauFiltre = await GET('/api/eleves/SE_niveaux');
        setDataFiltre((prevState) => ({
            ...prevState,
            niveau: creationTableauFiltre(niveauFiltre.data, 'idNiveau', 'libelle'),
        }));
        setFraitInscription(await valeurParametre('inscription', 'montantFraisInscription'));
    }
    async function requeteEtablissements(commune) {
        let communes = commune;
        if (commune === 'Autre') communes = ` Autre`;

        const etablissementsFiltre = await GET(`/api/eleves/SE_etablissements?mode=etablissements&commune=${communes}`, undefined, {
            redirectOnError: false,
        });
        setDataFiltre((prevState) => ({
            ...prevState,
            etablissement: creationTableauFiltre(etablissementsFiltre.data, 'idEtablissement', 'libelleEtablissement'),
        }));
    }
    useEffect(() => {
        if (!dataChoixOffre || !dataOffre) {
            if (valuesQuery('reinscription')) {
                history.push(`/accueilResponsable`);
            } else {
                history.push('/inscription/accueil');
            }
        }
        requeteSitesEtablissements();
        parametreDroitImage();
    }, []);
    function indexType(type, index) {
        if (option.includes('site/instrument')) {
            if (type === 'site/instrument') {
                return index;
            } else {
                return index + 1;
            }
        } else {
            return index;
        }
    }

    function dataIsSet(url) {
        if (dataChoixOffre.instrument) {
            if (dataOffre[valuesQuery('numeroEleve') - 1].scolarites[valuesQuery('numeroOffre') - 1].fk_instrument.length === 0) {
                return setErrorMessage('Les champs site et instrument sont obligatoires.');
            }
        }
        if (!dataOffre[valuesQuery('numeroEleve') - 1].scolarites[valuesQuery('numeroOffre') - 1].fk_site) {
            return setErrorMessage('Les champs site et instrument sont obligatoires.');
        } else {
            if (url === '/accueilResponsable') {
                if (!condition) return setCssText('red wavy underline');
                savescolariteInterne();
            }
            history.push(url);
        }
    }
    async function savescolariteInterne() {
        const data = dataOffre[valuesQuery('numeroEleve') - 1].scolarites[valuesQuery('numeroOffre') - 1];
        data.fk_eleve = +valuesQuery('idEleve');
        data.fk_idScolariteParent = null;
        if (droitImage === undefined && (+parametresDroit === 0 || (+parametresDroit === 1 && droitImage))) {
            const droit = {
                fk_eleve: data.fk_eleve,
                etat: 1,
                utilisateur: user[usurpation].idUtilisateur,
                fk_anneeScolaire: reinscription.valeur,
            };

            await POST('/api/droitImage/', droit);
            setDroitImage(true);
        }
        if (nonScolarise) {
            const dataScolarite = scolaritesExterne;
            dataScolarite.fk_eleve = data.fk_eleve;
            dataScolarite.fk_anneeScolaire = reinscription.valeur;
            await POST('/api/eleves/' + data.fk_eleve + '/scolaritesExterne/null', dataScolarite);
        }
        if (data.fk_instrument.length === 0) {
            data.fk_instrument = null;
            await POST('/api/eleves/' + +valuesQuery('idEleve') + '/scolaritesInterne/0', data);
        } else {
            for (let index = 0; index < data.fk_instrument.length; index++) {
                const objetScolarite = {};
                Object.assign(objetScolarite, data);
                objetScolarite.fk_instrument = data.fk_instrument[index];
                objetScolarite.commentaireInscription = `Choix de l' instrument: ${index + 1} \n ${data.commentaireInscription}`;
                await POST('/api/eleves/' + +valuesQuery('idEleve') + '/scolaritesInterne/0', objetScolarite);
            }
        }
    }
    function Bouton() {
        const defaultBouton = (
            <Button
                size="small"
                variant="contained"
                className={[css.BcBleu, css.radius10, css.cWhite, css.mb5, css.ml15]}
                onClick={() =>
                    dataIsSet(
                        valuesQuery('finalisation')
                            ? '/inscription/finalisationInscription'
                            : `/inscription/formulaireEleve?numeroEleve=${valuesQuery('numeroEleve')}${
                                  valuesQuery('reinscription') ? `&reinscription=true&idEleve=${valuesQuery('idEleve')}` : ''
                              }`,
                    )
                }
            >
                Continuer l'inscription
            </Button>
        );
        if (valuesQuery('reinscription')) {
            if (valuesQuery('idEleve') !== 'null') {
                return (
                    <>
                        <Button
                            size="small"
                            variant="contained"
                            className={[css.BcBleu, css.radius10, css.cWhite, css.mb5, css.ml15]}
                            onClick={() => setOpen(true)}
                        >
                            Finaliser cette offre
                        </Button>
                    </>
                );
            } else {
                return defaultBouton;
            }
        }
        if (!valuesQuery('reinscription')) {
            return defaultBouton;
        }

        return <></>;
    }

    function View() {
        return (
            <div className=" bgcfff h100 flex directionColumn p3">
                <DialogCustom
                    open={open}
                    onClose={() => setOpen(false)}
                    children={
                        CGUInscription && (
                            <>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: CGUInscription.message,
                                    }}
                                ></div>
                                <p className=" mt2" style={{ color: 'red' }}>
                                    {errorMessage}
                                </p>
                                <div className="flex alignICenter spaceBetween ">
                                    <div className="w70">
                                        {droitImage === undefined && +parametresDroit === 1 && (
                                            <div className="flex alignICenter">
                                                <Checkbox checked={droitImage} onChange={() => setDroitImage(!droitImage)} />
                                                <label>
                                                    J'autorise le conservatoire de musique du Tarn à utiliser mon image pour les besoins de sa communication.
                                                </label>
                                            </div>
                                        )}
                                        {+fraitInscription !== 0 && (
                                            <div className="flex alignICenter ">
                                                <Checkbox checked={condition} onChange={() => setCondition(!condition)} />
                                                <div className="flex directionColumn">
                                                    <label style={{ textDecoration: cssText }}>
                                                        Je comprends et j'accepte que chaque inscription validée donnera lieu à la facturation de{' '}
                                                        {fraitInscription}€ de frais de dossier qui s'ajoutent aux frais de scolarité.
                                                    </label>
                                                    {cssText !== 'none' && (
                                                        <label style={{ color: 'red', fontSize: '0.8em' }}>
                                                            Vous devez accepeter les conditions pour poursuivre votre inscription.
                                                        </label>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div>
                                        <Button className={[css.mb2]} onClick={() => setOpen(false)} color="secondary" variant="outlined" size="small">
                                            Retour
                                        </Button>
                                        <Button color="primary" variant="outlined" size="small" onClick={() => dataIsSet('/accueilResponsable')}>
                                            Je confirme l'inscription
                                        </Button>
                                    </div>
                                </div>
                            </>
                        )
                    }
                    maxWidth="md"
                />
                <div className="flex alignICenter w100">
                    <div className="flex  pl2 w55 radius10 directionColumn" style={{ border: `2px solid ${dataChoixOffre.couleur}` }}>
                        <h2 className="mb0">{dataChoixOffre.libelleOffre}</h2>
                        <div className="w100">
                            <p>{dataChoixOffre.sousTitre}</p>
                        </div>
                    </div>
                    {valuesQuery('finalisation') ? (
                        <></>
                    ) : (
                        <div className="flex directionColumn w50 alignICenter">
                            {valuesQuery('reinscription') ? null : (
                                <Link to="/inscription/FormulaireContact" className={[css.ml15]}>
                                    <Button size="small" variant="contained" className={[css.BcBleu, css.radius10, css.cWhite, css.mb5]}>
                                        Formulaire de contact
                                    </Button>
                                </Link>
                            )}
                            <Link
                                to={
                                    valuesQuery('parcours') === 'toutesOffres'
                                        ? `/inscription/ChoixScolarite?numeroEleve=${valuesQuery('numeroEleve')}&numeroOffre=${valuesQuery(
                                              'numeroOffre',
                                          )}&parcours=toutesOffres`
                                        : valuesQuery('reinscription')
                                        ? `/inscription/ChoixScolarite?numeroEleve=1&numeroOffre=1&reinscription=true&idEleve=${valuesQuery('idEleve')}`
                                        : `/inscription/PropositionOffre?numeroEleve=${valuesQuery('numeroEleve')}&numeroOffre=${valuesQuery('numeroOffre')}`
                                }
                                className={[css.ml15, css.w100]}
                            >
                                <Button size="small" variant="contained" className={[css.Bcf9cb9c, css.radius10, css.cWhite, css.w100]}>
                                    Retour
                                </Button>
                            </Link>
                        </div>
                    )}
                </div>
                {option.map((element, index) => (
                    <ElementDeSelectionOption
                        indexOffre={+valuesQuery('numeroOffre') - 1}
                        type={element}
                        index={indexType(element, index)}
                        color={dataChoixOffre.color}
                    />
                ))}
                <p className=" mt2" style={{ color: 'red' }}>
                    {errorMessage}
                </p>
                {valuesQuery('SE') === 'false' && (
                    <div className="flex alignICenter  mr5">
                        <Checkbox checked={nonScolarise} onChange={() => setNonScolarise(!nonScolarise)} />
                        <label className="w100">{`je connais la scolarité éducation nationale`}</label>
                    </div>
                )}
                {nonScolarise && valuesQuery('SE') === 'false' && (
                    <div className="p2 border1darkgrey radius10 w50 mb2">
                        <h4 className="textCenter nomargin mb2">Scolarité éducation nationale</h4>
                        {Object.keys(dataFiltre).map((e, i) => {
                            let label = '';
                            switch (e) {
                                case 'communes':
                                    label = { label: 'Ville', state: 'communes' };
                                    break;
                                case 'etablissement':
                                    label = {
                                        label: 'Établissement',
                                        state: 'fk_etablissementScolaire',
                                    };
                                    break;
                                case 'niveau':
                                    label = {
                                        label: `Niveau scolaire`,
                                        state: 'fk_niveauScolaire',
                                    };
                                    break;
                                default:
                                    break;
                            }
                            return (
                                <div className="mb5" key={i}>
                                    <span>{label.label} :</span>
                                    <FormControl className={[css.w100]}>
                                        <Select
                                            native={true}
                                            onChange={(event) =>
                                                label.state === 'communes'
                                                    ? requeteEtablissements(event.target.value)
                                                    : setScolaritesExterne((prevState) => ({
                                                          ...prevState,
                                                          [label.state]: +event.target.value,
                                                      }))
                                            }
                                        >
                                            <option value={''}></option>
                                            {dataFiltre[e].map((elem, index) => {
                                                return (
                                                    <option key={index} value={elem.id}>
                                                        {elem.libelle}
                                                    </option>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </div>
                            );
                        })}
                        <div className="flex alignICenter">
                            <Checkbox
                                checked={checkecedCourMercredi}
                                onChange={() => {
                                    setCheckecedCourMercredi(!checkecedCourMercredi);
                                    setScolaritesExterne((prevState) => ({
                                        ...prevState,
                                        coursMercrediMatin: checkecedCourMercredi ? 0 : 1,
                                    }));
                                }}
                            />
                            <label>Ecole mercredi matin</label>
                        </div>
                    </div>
                )}
                <div className="flex ">
                    <Bouton />
                </div>
            </div>
        );
    }
    if (dataChoixOffre) {
        return View();
    } else {
        return <></>;
    }
};

function mapDispatchToProps(dispatch) {
    return {
        ajoutOffre(numeroEleve) {
            dispatch({ type: 'ajoutoffre', numeroEleve: numeroEleve });
        },
    };
}

export default connect(null, mapDispatchToProps)(OptionOffre);
